import cx from "classnames"
import React from "react"

type InputWithDetailsBasePropsType = {
  title: string
  description?: string
  name: string
  className?: string
} & React.InputHTMLAttributes<HTMLInputElement>

export type InputWithDetailsPropsType = InputWithDetailsBasePropsType &
  (
    | { icon?: JSX.Element; illustrationUrl?: never }
    | { icon?: never; illustrationUrl?: string }
  )

const InputWithDetails = ({
  type,
  icon,
  illustrationUrl,
  title,
  description,
  className,
  ...inputProps
}: InputWithDetailsPropsType & { type: "radio" | "checkbox" }) => {
  const prefix = `cobalt-${type}-with-details`
  return (
    <label
      className={cx(
        prefix,
        !description && `${prefix}--noDescription`,
        className,
      )}
    >
      <input {...inputProps} type={type} className={`${prefix}__input`} />
      <div className={`${prefix}__inner`}>
        {illustrationUrl ? (
          <img
            alt={title}
            className={`${prefix}__illustration`}
            src={illustrationUrl}
          />
        ) : (
          icon &&
          React.cloneElement(icon, {
            className: `${prefix}__icon`,
          })
        )}
        <div className={`${prefix}__content`}>
          <div className={`${prefix}__title`}>{title}</div>
          {description && (
            <div className={`${prefix}__description`}>{description}</div>
          )}
        </div>
        <div className={`${prefix}__visual-input`} />
      </div>
    </label>
  )
}

export default InputWithDetails
